import React from 'react';

function Ecuador(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124145)">
        <mask
          id="mask0_800_124145"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124145)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#2E42A5"
          />
          <mask
            id="mask1_800_124145"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124145)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V12H36V0H0Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V24H36V18H0Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.9316 5.71427C10.9316 5.71427 15.6074 3.83665 16.0324 4.04996C16.4574 4.26326 16.5599 4.87124 16.9268 4.87124C17.2938 4.87124 18.0323 4.67912 18.3408 4.67912C18.6492 4.67912 18.954 4.87124 18.954 4.87124H20.271V4.22025L26.2427 5.71427C26.2427 5.71427 22.7597 6.11875 22.4972 6.11875C22.2347 6.11875 22.4972 6.45237 22.4972 6.45237C22.4972 6.45237 22.0005 6.11875 21.2442 6.11875C20.4878 6.11875 18.954 6.81332 18.954 6.81332L19.5115 7.87947L18.954 8.19297L18.3408 7.87947C18.3408 7.87947 18.3805 7.00271 18.1164 7.00271C17.8522 7.00271 17.6597 7.56596 17.6597 7.87947C17.6597 8.19297 16.9268 8.19297 16.9268 8.19297L17.2542 7.60607C17.2542 7.60607 17.5795 6.63303 16.9268 6.63303C16.2742 6.63303 13.2989 6.11875 13.2989 6.11875L12.5381 6.45237L12.8101 5.71427H10.9316Z"
              fill="#7B2900"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9391 15.7742C12.2093 14.3163 12.9391 11.0865 12.9391 11.0865L14.3574 11.7475C14.1891 12.5013 14.1628 13.9258 14.6935 15.0907C15.2242 16.2557 17.2304 17.1732 17.2304 17.1732C17.2304 17.1732 18.2425 17.3738 16.7047 17.5183C15.167 17.6628 13.6689 17.232 12.9391 15.7742ZM16.5751 21.5167C16.1182 21.5167 17.4889 18.8078 17.4889 18.8078L17.9119 18.0551C17.9119 18.0551 17.9637 21.2439 17.674 21.5167C17.4883 21.6916 17.2768 21.6422 17.0286 21.5843C16.8896 21.5518 16.7391 21.5167 16.5751 21.5167Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6179 15.298C11.0065 13.1211 11.9603 10.1649 11.9603 10.1649L12.9203 10.7746C12.7793 11.9002 12.7793 14.8111 13.5913 16.0723C14.4033 17.3336 17.9644 17.8634 17.9644 17.8634C17.9644 17.8634 17.2618 18.3251 15.9735 18.5409C14.6852 18.7567 12.2293 17.475 11.6179 15.298ZM15.7004 21.2171L16.2652 19.4247L17.0613 18.5589H17.6337C17.6337 18.5589 16.8279 21.6395 16.2652 21.6395C15.8997 21.6395 16.0091 21.4612 16.1306 21.2632C16.1962 21.1564 16.2652 21.0438 16.2652 20.9504C16.2652 20.6837 15.7004 21.2171 15.7004 21.2171Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.6851 15.671C10.3816 13.7972 10.9885 9.31995 10.9885 9.31995L11.9484 9.92963C11.5145 11.0141 11.6489 14.126 11.9484 15.671C12.2479 17.2161 15.0822 18.1475 15.0822 18.1475C15.0822 18.1475 14.3796 18.6091 13.0913 18.825C11.803 19.0408 10.9885 17.5449 10.6851 15.671ZM15.3973 19.4155C14.8507 19.4155 15.6356 18.7189 15.6356 18.7189H16.9441C16.9441 18.7189 16.4965 19.7028 15.9439 19.7028C15.6668 19.7028 15.6676 19.6306 15.6683 19.5586C15.6691 19.487 15.6698 19.4155 15.3973 19.4155Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.9112 15.7742C23.641 14.3163 22.9112 11.0865 22.9112 11.0865L21.493 11.7475C21.6612 12.5013 21.6876 13.9258 21.1569 15.0907C20.6262 16.2557 18.62 17.1732 18.62 17.1732C18.62 17.1732 17.6079 17.3738 19.1456 17.5183C20.6834 17.6628 22.1814 17.232 22.9112 15.7742ZM19.2752 21.5167C19.7321 21.5167 18.3614 18.8078 18.3614 18.8078L17.9385 18.0551C17.9385 18.0551 17.8867 21.2439 18.1763 21.5167C18.362 21.6916 18.5735 21.6422 18.8218 21.5843C18.9608 21.5518 19.1113 21.5167 19.2752 21.5167Z"
              fill="#E31D1C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.2324 15.298C24.8438 13.1211 23.89 10.1649 23.89 10.1649L22.93 10.7746C23.071 11.9002 23.071 14.8111 22.259 16.0723C21.447 17.3336 17.8859 17.8634 17.8859 17.8634C17.8859 17.8634 18.5885 18.3251 19.8768 18.5409C21.1651 18.7567 23.621 17.475 24.2324 15.298ZM20.1499 21.2171L19.5851 19.4247L18.7891 18.5589H18.2167C18.2167 18.5589 19.0225 21.6395 19.5851 21.6395C19.9506 21.6395 19.8412 21.4612 19.7197 21.2632C19.6542 21.1564 19.5851 21.0438 19.5851 20.9504C19.5851 20.6837 20.1499 21.2171 20.1499 21.2171Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.165 15.671C25.4684 13.7972 24.8616 9.31995 24.8616 9.31995L23.9017 9.92963C24.3356 11.0141 24.2012 14.126 23.9017 15.671C23.6022 17.2161 20.7679 18.1475 20.7679 18.1475C20.7679 18.1475 21.4705 18.6091 22.7588 18.825C24.0471 19.0408 24.8616 17.5449 25.165 15.671ZM20.4528 19.4155C20.9994 19.4155 20.2145 18.7189 20.2145 18.7189H18.906C18.906 18.7189 19.3536 19.7028 19.9062 19.7028C20.1833 19.7028 20.1825 19.6306 20.1818 19.5586C20.181 19.487 20.1803 19.4155 20.4528 19.4155Z"
              fill="#FECA00"
            />
            <path
              d="M11.478 10.4461L11.581 9.8937L13.3821 9.99734L12.016 8.73942L12.4762 8.35024L14.3239 10.0515L12.7443 7.41154L13.2903 7.12285L14.7285 9.00323L14.0425 7.04874L14.6323 6.84021L16.8437 10.7602L15.9954 10.7114L16.0785 10.9482L16.8007 11.1185L16.6361 11.6619L16.3013 11.583L16.6141 12.4743L16.0707 11.7638L17.0168 13.3443L14.6922 11.2037L11.478 10.4461Z"
              fill="#6FAE21"
            />
            <path
              d="M24.6667 10.4461L24.5637 9.8937L22.7627 9.99734L24.1288 8.73942L23.6685 8.35024L21.8209 10.0515L23.4005 7.41154L22.8544 7.12285L21.4163 9.00323L22.1023 7.04874L21.5124 6.84021L19.3011 10.7602L20.1494 10.7114L20.0663 10.9482L19.3441 11.1185L19.5086 11.6619L19.8435 11.583L19.5307 12.4743L20.0741 11.7638L19.1279 13.3443L21.4526 11.2037L24.6667 10.4461Z"
              fill="#6FAE21"
            />
            <path
              d="M12.4499 21.3113L11.9861 20.9254L25.7003 8.09064L26.1641 8.47651L12.4499 21.3113Z"
              fill="#171401"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.3521 8.18943L26.0552 8.77887L26.4515 7.80444L25.3521 8.18943Z"
              fill="#CECECC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.7982 21.3086L11.9906 20.8367L11.729 21.8041L12.7982 21.3086Z"
              fill="#CECECC"
            />
            <path
              d="M11.4302 19.3988L10.9663 19.0129L24.6805 6.17816L25.1443 6.56403L11.4302 19.3988Z"
              fill="#171401"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.332 6.27696L25.0352 6.86639L25.4315 5.89197L24.332 6.27696Z"
              fill="#CECECC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7785 19.3961L10.9708 18.9242L10.7092 19.8917L11.7785 19.3961Z"
              fill="#CECECC"
            />
            <path
              d="M23.9099 21.3113L24.3738 20.9254L10.6596 8.09064L10.1958 8.47651L23.9099 21.3113Z"
              fill="#171401"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.0078 8.18943L10.3047 8.77887L9.90834 7.80444L11.0078 8.18943Z"
              fill="#CECECC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.5614 21.3086L24.369 20.8367L24.6306 21.8041L23.5614 21.3086Z"
              fill="#CECECC"
            />
            <path
              d="M25.1851 19.8488L25.6489 19.4629L11.9348 6.62811L11.4709 7.01398L25.1851 19.8488Z"
              fill="#171401"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.2832 6.72691L11.58 7.31634L11.1837 6.34192L12.2832 6.72691Z"
              fill="#CECECC"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.8368 19.8461L25.6444 19.3741L25.906 20.3416L24.8368 19.8461Z"
              fill="#CECECC"
            />
            <rect
              x="15.375"
              y="16.375"
              width="5.1"
              height="2.25"
              fill="#B74E01"
            />
            <path
              d="M17.9412 17.2868C18.924 17.2868 19.7894 16.724 20.3991 15.8633C21.0092 15.002 21.3787 13.8251 21.3787 12.5368C21.3787 11.2485 21.0092 10.0716 20.3991 9.21032C19.7894 8.3496 18.924 7.7868 17.9412 7.7868C16.9583 7.7868 16.0929 8.3496 15.4833 9.21032C14.8731 10.0716 14.5037 11.2485 14.5037 12.5368C14.5037 13.8251 14.8731 15.002 15.4833 15.8633C16.0929 16.724 16.9583 17.2868 17.9412 17.2868Z"
              fill="#7DB8FF"
              stroke="#FECA00"
              strokeWidth="0.5"
            />
            <mask
              id="mask2_800_124145"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="14"
              y="7"
              width="8"
              height="11"
            >
              <path
                d="M17.9412 17.2868C18.924 17.2868 19.7894 16.724 20.3991 15.8633C21.0092 15.002 21.3787 13.8251 21.3787 12.5368C21.3787 11.2485 21.0092 10.0716 20.3991 9.21032C19.7894 8.3496 18.924 7.7868 17.9412 7.7868C16.9583 7.7868 16.0929 8.3496 15.4833 9.21032C14.8731 10.0716 14.5037 11.2485 14.5037 12.5368C14.5037 13.8251 14.8731 15.002 15.4833 15.8633C16.0929 16.724 16.9583 17.2868 17.9412 17.2868Z"
                fill="white"
                stroke="white"
                strokeWidth="0.5"
              />
            </mask>
            <g mask="url(#mask2_800_124145)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4895 12.6099H16.3033C16.3033 12.6099 17.5501 12.8555 16.9267 13.0487C16.3033 13.2419 16.3033 13.3058 16.3033 13.5813C16.3033 13.8569 16.3033 14.8652 16.3033 15.0805C16.3033 15.2959 16.7468 15.7569 15.812 15.7569C14.8772 15.7569 14.0718 12.3408 14.0718 12.3408L14.4895 12.6099Z"
                fill="#6FAE21"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5764 12.7955C21.5764 12.7955 19.8915 13.0914 18.7372 12.9928C17.583 12.8942 17.0764 12.7955 17.0764 12.7955C17.0764 12.7955 17.8809 13.1675 18.1669 13.4792C18.4528 13.791 19.0382 14.3299 19.635 14.3299C20.2317 14.3299 21.1465 14.8331 21.1465 14.8331L21.5764 12.7955Z"
                fill="#6FAE21"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.9835 10.1356C14.9835 10.1356 16.3724 10.3742 16.707 10.7315C17.0415 11.0888 16.2651 11.4461 18.2889 11.0888C20.3128 10.7315 21.9193 10.1083 21.9193 11.0888C21.9193 12.0693 21.7425 12.9725 20.8716 12.9725C20.0007 12.9725 19.6532 12.9725 16.9972 12.9725C14.3411 12.9725 12.8932 13.6946 13.0792 12.5327C13.2652 11.3708 14.9835 10.1356 14.9835 10.1356Z"
                fill="#F7FCFF"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124145">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Ecuador;
